export function getStripedGradientRuleFromColor(
  color1: string,
  color2: string,
  stripeWidth: number = 3,
  tilt: number = 45
) {
  return `repeating-linear-gradient(${tilt}deg, ${color1}, ${color1} ${stripeWidth}px, ${color2} ${stripeWidth}px, ${color2} ${stripeWidth * 2}px)`
}
